import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router';
import { CgProfile } from "react-icons/cg";
import { MdFlight } from "react-icons/md";
import Menu from '@material-ui/core/Menu';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import HistoryService from '../services/history.service';
import ToastContext from 'store/ToastContext';
import UserGuidService from '../services/userGuid.service';
import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';

import govSemel from '../images/Emblem_of_Israel.svg';
import PopulationImmigrationLogo from '../images/logoCustom.png';

import Environment from './Environment';

//import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
//import { GetObjectCommand } from '@aws-sdk/client-s3';
const useStyles = makeStyles({
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const Header = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { userInfo, signOut } = useContext(AuthContext);
  const classes = useStyles();
  const history = useHistory();
  const { openToast } = useContext(ToastContext);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [spinnerLoadingForHistory, setSpinnerLoadingForHistory] = useState(false);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirectFlightList = async () => {
    history.push("/FlightList", { airlineCode: userInfo.airlineCode })
  }
  const handleRemoveOldData=()=>{
    setSpinnerLoadingForHistory(true);

    HistoryService.deleteOldFlightsAndUploadedFiles()
    .then((Res) => {      
      setSpinnerLoadingForHistory(false);
      openToast("Old data have been deleted", "success");
    }).catch((error) => {
      setSpinnerLoadingForHistory(false);
      openToast("Error while deleting data", "error");
    });
  }
  const redirectUserManagement = () => {
    history.push("/UsersManagement");
    handleClose();
  }
  const redirectAdministratorManagement = () => {
    history.push("/AdministratorManagement");
    handleClose();
  }
  const redirectCertManagement = () => {
    history.push("/CertificatesManagement");
    handleClose();
  }
  const onDownloadHandler= ()=>{
    UserGuidService.getFileUrl(userInfo.role)
        .then((url)=>{           
           window.open(url, '_blank');                           
        })
        .catch((error)=>{
            alert(error)
        });    
  }

  return userInfo.isLoggedin ? (
    <React.Fragment>
      <header>
        <div>
          <CgProfile
            style={{
              fontSize: "30px",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={handleClick}
            id="profileLogoBtn"
          />
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            MenuListProps={{ style: { padding: 0 } }}
            onClose={handleClose}>
            <Card style={{ textAlign: "center" }}>
              <CardContent>
                <CgProfile style={{ fontSize: "50px" }} />
                <Typography variant="h5" component="h2">
                  {userInfo?.firstName + " " + userInfo?.lastName}
                </Typography>
                <Typography
                  className={classes.pos}
                  color="textSecondary"
                  component={"div"}>
                  {userInfo?.email}
                </Typography>
                <Typography
                  className={classes.pos}
                  color="textSecondary"
                  component={"span"}>
                  phoneNumber: {userInfo?.phoneNumber}
                </Typography>
                <Typography
                  className={classes.pos}
                  color="textSecondary"
                  component={"span"}>
                  {userInfo.faxNumber ? "Fax Number: " : null}
                  {userInfo?.faxNumber}
                </Typography>
              </CardContent>
              <CardActions>
                {userInfo.role === "admin" && (
                  <div className="col-12">
                    <AppButton id="userMngBtn" classes="text-center" action={redirectUserManagement} label="User Management"></AppButton> </div>
                )}
                {userInfo.isOwner && (
                  <div className="col-12">
                    <AppButton id="adminMngBtn" action={redirectAdministratorManagement} label="Administrator Management"></AppButton></div>
                )}                 
              </CardActions>          
              <CardActions>    
              {!userInfo.isOwner && (
                  <div className="col-12">
                    <AppButton id="userGuidBtn" action={onDownloadHandler} label="User Guide" isLoading={spinnerLoading}></AppButton></div>
                )}                           
              </CardActions>
              <CardActions>
              {(userInfo.role !== "user") && (              
                <div className="col-12">
                  <AppButton id="adminCertMngBtn" action={redirectCertManagement} label="Certificates Management" isLoading={spinnerLoading}></AppButton></div>                
              )}
              </CardActions>
              <CardActions>
              {userInfo.isOwner && (
                  <div className="col-12">
                    <AppButton id="adminMngBtn" action={handleRemoveOldData} label="Remove Old Data" isLoading={spinnerLoadingForHistory}></AppButton></div>
                )}
              </CardActions>
              <Typography
                className={classes.pos}
                color="textSecondary"
                component={"span"}>
                <hr />
              </Typography>
              <CardActions>
                <div className="col-12">
                  <AppButton id="signOutBtn" action={() => {
                    handleClose();
                    signOut();
                  }} label="Sign Out"></AppButton></div>
              </CardActions>
            </Card>
          </Menu>
          {!userInfo.isOwner && (
            <AppButton action={redirectFlightList} size="lg" label="Manage my flights" id="mngFlightsBtn" icon={<MdFlight />}></AppButton>
          )}
        </div>
        <hr />
        <div className="row">
          <div className="col-md-10 mx-auto">
            <div className="form-group row">
              <div className="col-sm-3">
                <div
                  className="pull-left"
                  style={{ float: "left" }}
                  id="govLogo">
                  <img src={govSemel} height="70" className="gov" alt='semel' />
                </div>
              </div>

              <div
                className="col-sm-6 d-flex justify-content-center align-items-center"
                style={{ cursor: "pointer" }}
                onClick={()=> history.push("/")}
                id="mainTitle">
                <h2 className="PortalTitle">
                  Israel iAPI Portal for Airlines
                </h2>
              </div>
              <div className="col-sm-3" id="popImigrationLogo">
                <img
                  src={PopulationImmigrationLogo}
                  style={{ float: "right" }}
                  className="center"
                  height="70"
                  alt="Population"
                />
              </div>
            </div>
          </div>
        </div>
      
     <Environment/>   
       <hr /> </header>
    </React.Fragment>
  ) : (
    <div></div>
  );
}

export default Header;
